import React, { useState } from "react";
import { UnmountClosed } from "react-collapse";
import { compose } from "redux";

import connectProps from "fantastic/lib/connectProps";
import connectActions from "fantastic/lib/connectActions";

import cancelFavorite from "fantastic/actions/cancelFavorite";
import updateFavorite from "fantastic/actions/updateFavorite";
import destroyEntity from "fantastic/actions/destroyEntity";

import ModalAction from "fantastic/components/common/ModalAction";

import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import SelectTagsSetting from "fantastic/components/common/controls/SelectTagsSetting";

const Favorite = ({
  favorite,
  cancelFavorite,
  updateFavorite,
  destroyEntity,
  user_tags,
  updating,
  enabled,
  query,
  selectedTags
}) => {
  if (!favorite || favorite === null || !enabled) return null;

  const { tag_list = [] } = favorite;
  const SELF_TAG = i18n.t('my_blocks');

  const favoritesTags = [SELF_TAG];
  const filteredTags = user_tags.filter(t => t !== SELF_TAG);
  const [tags, setTags] = useState([...favoritesTags, ...filteredTags]);
  const [values, setValues] = useState(tag_list);

  const emptyEntity = { id: null, name: "", data: null };

  const [entity, setEntity] = useState({
    ...emptyEntity,
    ...favorite,
    ...{ name: favorite.name ? favorite.name : "" }
  });

  const handleChangeName = name => setEntity({ ...entity, name });

  const toggleValue = tag => {
    if (tags.includes(tag)) {
      if (values.includes(tag)) {
        setValues(values.filter(t => t !== tag));
      } else {
        setValues([...values, tag]);
      }
    } else {
      setTags([...new Set([...tags, tag])]);
      setValues([...values, tag]);
    }
  };

  const renderAddNewTagLink = active => (
    <a onClick={() => { active(true); }}>{ i18n.t('tags_add') }</a>
  );
  const renderDescription = active => (
    <>
      { i18n.t('tags_desc1') } { renderAddNewTagLink(active) } { i18n.t('tags_desc2') }
    </>
  );

  const renderHeader = () => {
    if (!favorite.id)
      return (
        <div className="action-modal__header--caption">
          { i18n.t('element_new') }
        </div>
      );

    return (
      <>
        <div className="action-modal__header--caption">
          { i18n.t('element_edit') }
        </div>
        <a
          className="btn btn-remove"
          title={i18n.t('remove')}
          onClick={() => {
            destroyEntity(favorite.id);
            cancelFavorite();
          }}
        />
      </>
    );
  };

  return (
    <ModalAction
      onAccept={() => updateFavorite({ ...entity, tag_list: values })}
      onReject={() => cancelFavorite()}
      textReject={i18n.t('cancel')}
      textAccept={i18n.t('save')}
      header={renderHeader()}
      disabled={updating && updating === "start"}
    >
      <SingleStringSetting
        label={i18n.t('element_name')}
        value={entity.name}
        placeholder={i18n.t('element_my')}
        onChange={handleChangeName}
        description={i18n.t('element_name_desc')}
      />
      <SelectTagsSetting
        tags={tags}
        values={values}
        locked={favoritesTags}
        favorite={favoritesTags}
        onChange={toggleValue}
        description={renderDescription}
      />
    </ModalAction>
  );
};

export default compose(
  connectProps({
    favorite: state => state.collections.favorite,
    user_tags: state => state.collections.tags,
    updating: state => state.collections.favorite_updating,
    enabled: state => state.collections.enabled,
    query: state => state.collections.query,
    selectedTags: state => state.collections.selectedTags
  }),
  connectActions({ cancelFavorite, updateFavorite, destroyEntity })
)(Favorite);
